module.exports = __webpack_public_path__ + "img/metamask.c06f3a3e.svg";